// Estimate Invoices — bills raised off a quotation with no GST charged.
//
// Its own section rather than part of the proforma/tax invoice queues: these documents never carry
// tax, so they must not be mixed into the GST invoice lists.

import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Calculator } from 'lucide-react';
import { AccountingSubNav } from '@/components/sales/AccountingSubNav';
import { EstimateInvoiceSection } from '@/components/sales/EstimateInvoiceSection';

export function EstimateInvoicesPage() {
  const navigate = useNavigate();

  return (
    <div className="flex h-full flex-col gap-6 overflow-y-auto pr-1">
      <AccountingSubNav />

      <div className="flex items-center gap-3.5">
        <button
          onClick={() => navigate(-1)}
          className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-tr from-[#6825F5] to-[#7C3AED] text-white shadow-sm shadow-purple-200 hover:shadow-md transition-shadow"
          title="Back"
        >
          <ArrowLeft className="w-5 h-5 text-white" />
        </button>
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-tr from-[#6825F5] to-[#7C3AED] text-white shadow-sm shadow-purple-200">
          <Calculator className="h-6 w-6 text-white" />
        </div>
        <div>
          <span className="block text-[11px] font-bold tracking-wider text-[#6825F5] uppercase">
            ESTIMATE INVOICES
          </span>
          <h1 className="text-xl md:text-2xl font-bold tracking-tight text-[#11183F]">
            Bill a client from a quotation with no GST charged.
          </h1>
        </div>
      </div>

      <EstimateInvoiceSection />
    </div>
  );
}

export default EstimateInvoicesPage;
